// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    DEVICES_OVERVIEW_GET_DATA_REQUEST,
    DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST,
    DEVICES_OVERVIEW_REFRESH_FIRMWARES
} from 'Redux/actionTypes';

// Actions
import {
    devicegetDataResult,
    deviceGetCtcInfoResult,
    deviceFirmwaresRefreshRequestResult,
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getDevice({ payload }) {
    const { id } = payload;
    let data = {};
    try {
        let QUERY_UNIT = `
            query getUnit ($id: Int!) {
                result: getUnit (id: $id) {
                    id
                    companyId
                    company {
                        id
                        name
                        status
                        sm
                        username
                        email
                        dealer {
                            id
                        }
                    }
                    label
                    esn
                    imei
                    simCard {
                        iccId
                        msisdn
                        simProviderAccount {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                    }
                    network
                    deviceCategory
                    status
                    statusUpdatedOn
                    deviceModel {
                        id
                        name
                        manufacturer {
                            id
                            name
                        }
                    }
                    linkedMode
                    liveMode
                    linkedUnitId
                    linkedUnit {
                        id
                        label
                        esn
                        deviceModel {
                            id
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    linkedByUnit {
                        id
                        label
                    }
                    configStatus
                    isRefurbished
                    isRMA
                    reference
                    sdCard
                    refurbishedUnit {
                        refurbishedUnitId
                        esn
                    }
                    lastReading {
                        unitTime
                        serverTime
                        lastMessageTime
                        deviceData
                    }
                    unitConfig {
                        unitId
                        calampApi
                        accountId
                        configVersion
                        scriptVersion
                        pulsCustomerId
                        pulsGroup
                        movingFrequency
                        stoppedFrequency
                        password
                        cameraInfo
                        cameraInfoUpdated
                        simState
                        firmwareId
                        hardwareVersion
                        cameraConfig
                        createdBy
                        createdOn
                        updatedBy
                        updatedOn
                        coverageScore
                        coverageUpdatedOn
                        billingAccountId
                        billingAccount {
                            id
                            name
                        }
                    }
                    show
                    nextScheduledAction
                    createdBy
                    createdOn
                    timezone
                    installed
                    installedOn
                    offsetEngineHours
                    offsetEcuEngineHours
                    offsetEngineOdometer
                    offsetEcuEngineOdometer
                    tags
                }
            }
        `;
        try {
            data = yield call(
                clientQuery,
                QUERY_UNIT,
                { id: id },
                endpoints.GRAPHQL_GENERAL,
            );
        } catch (exc1) {

        }
        if (data.result) {
            yield put(devicegetDataResult({ data: data.result }));
        } else {

            QUERY_UNIT = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                    companyId
                    company {
                        id
                        name
                        status
                        sm
                        username
                        email
                        dealer {
                            id
                        }
                    }
                    label
                    esn
                    imei
                    simCard {
                        iccId
                        msisdn
                        simProviderAccount {
                            id
                            name
                            simProviderId
                            simProvider {
                                id
                                name
                            }
                        }
                    }
                    network
                    deviceCategory
                    status
                    statusUpdatedOn
                    deviceModel {
                        id
                        name
                        manufacturer {
                            id
                            name
                        }
                    }
                    linkedMode
                    liveMode
                    linkedUnitId
                    linkedUnit {
                        id
                        label
                        esn
                        deviceModel {
                            id
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    linkedByUnit {
                        id
                        label
                    }
                    configStatus
                    isRefurbished
                    isRMA
                    reference
                    sdCard
                    refurbishedUnit {
                        refurbishedUnitId
                        esn
                    }
                    lastReading {
                        unitTime
                        serverTime
                        lastMessageTime
                        deviceData
                    }
                    unitConfig {
                        unitId
                        calampApi
                        accountId
                        configVersion
                        scriptVersion
                        pulsCustomerId
                        pulsGroup
                        movingFrequency
                        stoppedFrequency
                        password
                        cameraInfo
                        cameraInfoUpdated
                        simState
                        firmwareId
                        hardwareVersion
                        cameraConfig
                        createdBy
                        createdOn
                        updatedBy
                        updatedOn
                        coverageScore
                        coverageUpdatedOn
                        billingAccountId
                        billingAccount {
                            id
                            name
                        }
                    }
                    show
                    nextScheduledAction
                    createdBy
                    createdOn
                    timezone
                    installed
                    installedOn
                    offsetEngineHours
                    offsetEcuEngineHours
                    offsetEngineOdometer
                    offsetEcuEngineOdometer
                    tags
                    }
                }
            }
            `;

            data = yield call(
                clientQuery,
                QUERY_UNIT,
                {
                    conditions: {
                        fields: ["esn"],
                        terms: [id],
                        exact: true
                    },
                    limit: 1,
                    offset: 0
                },
                endpoints.GRAPHQL_GENERAL,
            );

            if (data.result) {
                const { items } = data.result;
                let newUnit = items[0];
                if (newUnit) {
                    yield put(devicegetDataResult({ data: newUnit }));
                } else {
                    yield put(devicegetDataResult({ error: true }));
                }
            } else
                yield put(devicegetDataResult({ error: true }));
        }

    } catch (exc) {
        yield put(devicegetDataResult({ error: true }));
    }
}

function* refreshFirmwares({ payload }) {

    try {
        let QUERY_REFRESH = `
        mutation refreshFirmwares ($hardwareVersion: String, $build: String) {
            result: refreshFirmwares (hardwareVersion: $hardwareVersion, build: $build)
        }
        `;


        let data = yield call(
            clientMutation,
            QUERY_REFRESH,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(deviceFirmwaresRefreshRequestResult(data));

    } catch (exc) {
        yield put(deviceFirmwaresRefreshRequestResult({ error: exc }));
        ExceptionManager(
            exc,
            "Modules/devices/views/overview/redux/saga",
            "refreshFirmwares"
        )
    }
}

function* getCtcInfo({ payload }) {
    try {
        const { esn } = payload;
        let data = {};
        let QUERY_CTC_INFO = `
        query searchCTCDeviceByESN($esn: String!) {
            result: searchCTCDeviceByESN(esn: $esn)
        }
        `;

        data = yield call(
                clientQuery,
                QUERY_CTC_INFO,
                { esn },
                endpoints.GRAPHQL_GENERAL,
            );

        if (data.result) {
            let result;
            try {
                result = JSON.parse(data?.result);
                yield put(deviceGetCtcInfoResult(result));
            } catch (parseError) {
                yield put(deviceGetCtcInfoResult({
                    error: true,
                    message: "Malformed CTC response format: JSON.parse failed.",
                    details: parseError.message,
                    rawResponse: data?.result
                }));
            }
        } else {
            yield put(deviceGetCtcInfoResult({ error: true }));
        }
    } catch (exc) {
        yield put(deviceGetCtcInfoResult({ error: exc }));
    }
}

function* watchMethods() {
    yield takeEvery(DEVICES_OVERVIEW_GET_DATA_REQUEST, getDevice);
    yield takeEvery(DEVICES_OVERVIEW_REFRESH_FIRMWARES, refreshFirmwares);
    yield takeEvery(DEVICES_OVERVIEW_GET_CTC_INFO_REQUEST, getCtcInfo);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}